import React, { useEffect } from "react";
import { Link } from "react-router-dom";

const NotFound = () => {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = "Page Not Found | 'ALOHI Skin & Wellness";

    // Add noindex meta so search engines don't index unknown routes served by SPA fallback.
    const meta = document.createElement("meta");
    meta.name = "robots";
    meta.content = "noindex, follow";
    meta.setAttribute("data-testid", "notfound-noindex");
    document.head.appendChild(meta);

    return () => {
      document.title = prevTitle;
      if (meta.parentNode) meta.parentNode.removeChild(meta);
    };
  }, []);

  return (
    <div
      data-testid="notfound-page"
      style={{
        minHeight: "80vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "80px 24px",
        background: "#FAF9F6",
        color: "#1A1A18",
        fontFamily: "'Cormorant Garamond', Georgia, serif",
        textAlign: "center"
      }}
    >
      <span
        style={{
          fontFamily: "'Outfit', sans-serif",
          fontSize: 11,
          letterSpacing: "0.32em",
          textTransform: "uppercase",
          color: "#B59A65",
          marginBottom: 16
        }}
      >
        404 · Not Found
      </span>
      <h1
        style={{
          fontSize: "clamp(48px, 8vw, 96px)",
          fontWeight: 300,
          letterSpacing: "-0.02em",
          margin: "0 0 20px",
          lineHeight: 1.02
        }}
      >
        This page has drifted.
      </h1>
      <p
        style={{
          fontSize: 19,
          color: "#3a352d",
          maxWidth: 520,
          margin: "0 0 40px",
          fontWeight: 300,
          lineHeight: 1.6
        }}
      >
        The page you were looking for isn&apos;t here. Return to the homepage or explore
        our journal, services, and products.
      </p>
      <div style={{ display: "flex", gap: 16, flexWrap: "wrap", justifyContent: "center" }}>
        <Link
          to="/"
          data-testid="notfound-home-link"
          style={{
            background: "#1A1A18",
            color: "#FAF9F6",
            padding: "16px 36px",
            fontFamily: "'Outfit', sans-serif",
            fontSize: 12,
            letterSpacing: "0.28em",
            textTransform: "uppercase",
            textDecoration: "none"
          }}
        >
          Return Home
        </Link>
        <Link
          to="/services"
          data-testid="notfound-services-link"
          style={{
            color: "#1A1A18",
            padding: "16px 36px",
            fontFamily: "'Outfit', sans-serif",
            fontSize: 12,
            letterSpacing: "0.28em",
            textTransform: "uppercase",
            textDecoration: "none",
            borderBottom: "1px solid #1A1A18"
          }}
        >
          Aesthetic Services
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
